<template>
  <ws-role-node :only="['front_me', 'front_admin']">
  <div class="list">
    <div class="list__item" v-for="elem in radioList" :key="elem.name">
      <p class="list__item-title">{{elem.label}}</p>
      <div class="list__radios">
        <b-radio
            v-for="item in options"
            :key="item.id"
            v-model="form[elem.name]"
            v-validate="'required'"
            :native-value="item.value"
            data-vv-as="Подтверждаю готовность ЦПДЭ к проведению ДЭ"
            type="is-info"
            :name="elem.name"
            class="list__radio"
            @input="updateMethod(elem.name, item.value)"
            :disabled="!disabled"
        >
          {{item.label}}
        </b-radio>
      </div>
    </div>
  </div>
  </ws-role-node>
</template>

<script>
import { debounce } from 'debounce'

const options = [
  { id: '1', label: 'да', value: true }, { id: '2', label: 'нет', value: false }
]
const TYPE_FORM = {
  IS_READY_CPDE: 'is_ready_CPDE',
  IS_READY_CPDE_DOCUMENTS: 'is_ready_CPDE_documents',
  IS_READY_EXPERT_GROUP: 'is_ready_expert_group',
  IS_READY_CPDE_STUFFS: 'is_ready_CPDE_stuffs'
}
const radioList = [
  {
    label: 'Подтверждаю готовность ЦПДЭ к проведению ДЭ',
    name: TYPE_FORM.IS_READY_CPDE
  },
  {
    label: 'ЦПДЭ соответствует требованиям комплекта оценочной документации',
    name: TYPE_FORM.IS_READY_CPDE_DOCUMENTS
  },
  {
    label: 'Экспертная группа соответствует установленным требованиям',
    name: TYPE_FORM.IS_READY_EXPERT_GROUP
  },
  {
    label: 'ЦПДЭ имеет в наличии необходимое оборудование/ инструменты/ расходные материалы для выполнения заданий, в полном объёме.',
    name: TYPE_FORM.IS_READY_CPDE_STUFFS
  }
]
export default {
  name: 'WsReadinessCPDEForm',
  props: {
    exam: Object
  },
  data () {
    return {
      options,
      radioList,
      form: {
        [TYPE_FORM.IS_READY_CPDE]: this.exam[TYPE_FORM.IS_READY_CPDE],
        [TYPE_FORM.IS_READY_CPDE_DOCUMENTS]: this.exam[TYPE_FORM.IS_READY_CPDE_DOCUMENTS],
        [TYPE_FORM.IS_READY_EXPERT_GROUP]: this.exam[TYPE_FORM.IS_READY_EXPERT_GROUP],
        [TYPE_FORM.IS_READY_CPDE_STUFFS]: this.exam[TYPE_FORM.IS_READY_CPDE_STUFFS]
      }
    }
  },
  computed: {
    disabled () {
      return this.exam.status === 'approved_main_expert' || this.exam.status === 'complete_main_expert'
    }
  },
  methods: {
    updateMethod: debounce(function (name, value) {
      this.update(name, value)
    }, 1000),

    async update (name, value) {
      try {
        const url = `${__config.api_url}/api/de/exams/${this.exam.guid}/is-ready`

        const res = await this.$http.put(url, {
          ...this.form,
          [name]: value
        })
        this.form = {
          ...this.form,
          [name]: res.data.data[name]
        }
      } catch (err) {
        this.$buefy.toast.open({
          message: this.$t(`Что-то пошло не так`),
          type: 'is-danger'
        })
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.list{
  background-color: transparent;
  border-radius: 100%;
  box-shadow: none;
  max-width: 491px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 17px;

  &__item{
    display: grid;
    align-items: flex-start;
    grid-template-columns: 400fr 51fr;
    gap: 40px;
    padding-bottom: 5px;
    border-bottom: 1px solid #DBDBDB;

    &-title{
      font-size: 16px;
      color: black;
    }
  }

  &__radios{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 5px;
  }

  &__radio{
    margin-left: 0 !important;
  }
}
</style>
